
<script>
import AdminNavbarHeader from "@/components/AdminNavbarHeader";
import { useUiStore } from "../stores/ui";
import { useUserStore } from "../stores/user";

export default {
  setup() {
    const uiStore = useUiStore();
    const userStore = useUserStore();
    const isAdminFileDownloader = userStore.isAdminFileDownloader;

    return {
      uiStore,
      isAdminFileDownloader,
    };
  },
  name: "Navbar",
  components: {
    AdminNavbarHeader,
  },
  data() {
    if (this.isAdminFileDownloader) {
      return {
        categoriesList: [
          {
            icon: "list",
            name: "components.admin_navbar.imported_data",
            path: "/admin/imported-data",
            isDisabled: false,
          },
          {
            icon: "desktop",
            name: "components.admin_navbar.return",
            path: "/",
            isDisabled: false,
          },
        ],
      };
    }

    return {
      categoriesList: [
        {
          icon: "border-all",
          name: "components.admin_navbar.dashboard",
          path: "/admin",
          isDisabled: false,
        },
        {
          icon: "list",
          name: "components.admin_navbar.user_validation",
          path: "/admin/user-validation",
          isDisabled: false,
        },
        {
          icon: "list",
          name: "components.admin_navbar.commune_account",
          path: "/admin/commune-account",
          isDisabled: false,
        },
        {
          icon: "list",
          name: "components.admin_navbar.admin_account",
          path: "/admin/admin-account",
          isDisabled: false,
        },
        {
          icon: "edit",
          name: "components.admin_navbar.faq_editor",
          path: "/admin/faq-editor",
          isDisabled: true,
        },
        {
          icon: "edit",
          name: "components.admin_navbar.text_editor",
          path: "/admin/text-editor",
          isDisabled: true,
        },
        {
          icon: "list",
          name: "components.admin_navbar.imported_data",
          path: "/admin/imported-data",
          isDisabled: false,
        },
        {
          icon: "desktop",
          name: "components.admin_navbar.return",
          path: "/",
          isDisabled: false,
        },
      ],
    };
  },
  computed: {
    isReduce() {
      return this.uiStore.reduce;
    },
  },
  created() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    )
      this.uiStore.reduceNavbar();
  },
};
</script>

<template>
  <div
    id="maindiv"
    class="h-full overflow-y-auto bg-adminNavbarLight"
    :class="[!isReduce ? 'w-0 md:w-72' : 'w-20']"
  >
    <AdminNavbarHeader :is-reduce="isReduce" />
    <ul>
      <router-link
        v-for="category in categoriesList"
        :key="category.name"
        :to="category.path"
      >
        <button
          :disabled="category.isDisabled === true"
          :class="
            category.isDisabled
              ? 'no-cursor opacity-50'
              : 'hover:bg-adminNavbarDark'
          "
          class="px-6 py-4 w-full flex items-center text-adminNavbarInactive truncate overflow-hidden focus:outline-none border-l-4 border-solid border-transparent"
        >
          <font-awesome-icon :icon="category.icon" />
          <router-view>
            <transition name="fade">
              <span v-if="!isReduce" class="ml-2 text-sm font-semibold">{{
                $t(category.name)
              }}</span>
            </transition>
          </router-view>
        </button>
      </router-link>
    </ul>
  </div>
</template>

<style scoped>
* {
  will-change: opacity, width, height;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 300ms ease;
}

.fade-leave-active {
  transition: opacity 150ms ease;
}

#logoContainer {
  transition: height 150ms ease;
}

.fade-enter-active {
  transition: opacity 300ms ease;
}

.fade-leave-active {
  transition: opacity 150ms ease;
}

#maindiv {
  transition: width 300ms ease;
}

.router-link-exact-active > button {
  @apply border-airbnbRed bg-adminNavbarDark;
}

.no-cursor {
  cursor: default !important;
}
</style>
